const { userAgent, maxTouchPoints, platform } = navigator;
import { Capacitor } from '@capacitor/core';

export function isMobileBrowser() {
    let OS = getOS();
    return OS === 'android' || OS === 'ios';
}

export function getOS(){
    let OS;
    if (userAgent.match(/Android/i)) {
        OS = 'android';
    } else if (userAgent.match(/iP(ad|hone|od)/i) || (maxTouchPoints && maxTouchPoints > 2 && /MacIntel/.test(platform))) {
        OS = 'ios';
    } else if (userAgent.match(/Mac(intosh| OS X)/i)) {
        OS = 'macos';
    } else if (userAgent.match(/Windows/i)) {
        OS = 'windows';
    }
    return OS;
}

export function isSupportedMobileBrowser() {
    let OS = getOS();
    return (OS === 'android' && JitsiMeetJS.util.browser.isSupportedAndroidBrowser())
        || (OS === 'ios'  && (Capacitor.isNativePlatform() || JitsiMeetJS.util.browser.isSupportedIOSBrowser()));
}

export function isCapacitor() {
    return Capacitor !== undefined && Capacitor.isNativePlatform();
}

export function supportJitsi(){
    if (navigator.product === 'ReactNative') {
        return false;
    }
    return isMobileBrowser() ? isSupportedMobileBrowser() : JitsiMeetJS.isWebRtcSupported();
}
